import { all, fork } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';

export default function* daDeviationRootSaga() {
  yield all([
    // shared sagas
    ...sagas.map(fork),
  ]);
}
